var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-tree-wrapper"},[_c('div',{staticClass:"file-item",class:{ 
      'folder-item': _vm.file.isDirectory,
      'image-item': !_vm.file.isDirectory,
      'active': _vm.isSelected
    },on:{"click":_vm.handleClick}},[(_vm.file.isDirectory)?_c('i',{staticClass:"file-icon folder-closed"}):_c('i',{staticClass:"file-icon image-file"}),_c('span',{staticClass:"file-name"},[_vm._v(_vm._s(_vm.file.name))]),(_vm.isSelected && !_vm.file.isDirectory)?_c('i',{staticClass:"el-icon-check selected-icon"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }